import EnumSet from 'Services/enumSet'

interface IChatDetailsModeMobile extends EnumSet {
  chat: number
  details: number
}

const ChatDetailsModeMobile = new EnumSet({
  chat: { value: 1, description: 'chat' },
  details: { value: 2, description: 'details' },
}) as IChatDetailsModeMobile

export default ChatDetailsModeMobile


